import { render, staticRenderFns } from "./ActionResetUserPassword.vue?vue&type=template&id=37f465f0&"
import script from "./ActionResetUserPassword.vue?vue&type=script&lang=js&"
export * from "./ActionResetUserPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports